import { AnalyticPeriodsEnum } from '@workalizer/shared';
import { groupByPeriod } from '@workalizer/shared/utils';
import { formatISO, setMinutes, setSeconds } from 'date-fns';
export var ChatRoomMessagePostedTypeEnum;
(function (ChatRoomMessagePostedTypeEnum) {
    ChatRoomMessagePostedTypeEnum["MESSAGE_POSTED"] = "MESSAGE_POSTED";
    ChatRoomMessagePostedTypeEnum["MESSAGE_POSTED_IN_SPACE"] = "MESSAGE_POSTED_IN_SPACE";
})(ChatRoomMessagePostedTypeEnum || (ChatRoomMessagePostedTypeEnum = {}));
export var processChatAnalytic = function (chatEvent, dateFrom, dateTo, groupBy) {
    var mappedData = groupBy === AnalyticPeriodsEnum.HOUR
        ? chatEvent.map(function (event) { return ({
            items: [event],
            date: formatISO(setSeconds(setMinutes(new Date(event.date), 0), 0))
        }); })
        : chatEvent.map(function (event) { return ({
            items: [event],
            date: formatISO(event.date, { representation: 'date' })
        }); });
    var chatAnalyticsGroupedByDate = groupByPeriod(mappedData, dateFrom, dateTo, groupBy);
    var analytics = chatAnalyticsGroupedByDate.map(function (item) {
        var postedMessages = item.items.reduce(function (acc, event) {
            if (event.room_type_group === ChatRoomMessagePostedTypeEnum.MESSAGE_POSTED) {
                return acc + Number(event.count);
            }
            return acc;
        }, 0);
        var postedMessagesInSpaces = item.items.reduce(function (acc, event) {
            if (event.room_type_group ===
                ChatRoomMessagePostedTypeEnum.MESSAGE_POSTED_IN_SPACE) {
                return acc + Number(event.count);
            }
            return acc;
        }, 0);
        return {
            date: item.date,
            postedMessages: postedMessages,
            postedMessagesInSpaces: postedMessagesInSpaces
        };
    });
    return analytics;
};
